import * as t from 'io-ts';

import {mergeTimestamps} from '../helpers/merge';

/*
 * Constants.
 */

export enum DismissedSuggestionKeysEnum {
  LIVE_DASHBOARD_SUGGESTION = 'liveDashboardSuggestion',
  TEAM_CHANNEL_SUGGESTION = 'teamChannelSuggestion',
  ENABLE_AI_COPILOT_SUGGESTION = 'enableAiCopilotSuggestion',
  CONFIGURE_AI_WORKSPACE_SETTINGS_SUGGESTION = 'configureAiWorkspaceSettingsSuggestion',
  CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_SUGGESTION = 'configureAiCopilotKnowledgeBaseSuggestion',
  DISCARD_SUGGESTED_REPLY_KNOWLEDGE_BASE_SUGGESTION = 'discardSuggestedReplyKnowledgeBaseSuggestion',
}

export const defaultDismissedSuggestions = {};

/*
 * Runtime types.
 */

export const RDismissedSuggestions = t.record(t.string, t.number);

/*
 * Merge strategy.
 */

export function mergeDismissedSuggestions(
  left: Record<string, number>,
  right: Record<string, number>,
): Record<string, number> {
  return mergeTimestamps(left, right);
}
